import {createSelector} from 'reselect';

import {getQuickLinksAsObject} from 'Components/layouts/kiosk/KioskLayout/kioskLayoutUtils';
import {CONFIG_DATA_BASE_KEYS} from 'Utils/constants';

const quickLinks = state =>
    state.pageState?.layout?.config?.signConfig[CONFIG_DATA_BASE_KEYS.WITH_INHERITANCE]
        ?.quickLinks || {};

const getQuickLinks = createSelector(quickLinks, _quickLinks => {
    const quickLinksObject = getQuickLinksAsObject();
    return Object.entries(_quickLinks) // enumerate quickLinks from store
        .filter(quickLink => quickLink[1]) // only get checked or bool(true) quickLink
        .map(quickLink => {
            // get the corresponding object for the checked quickLink
            const key = `quick-links-${quickLink[0]}`;
            return quickLinksObject[key];
        })
        .map(ql => {
            return {
                uuid: ql.id,
                icon: {
                    backgroundColor: ql.icon.backgroundColor,
                    iconUrl: ql.icon.src,
                    name: ql.title,
                },
                label: ql.title,
                isFeatureType: true,
                featureTypes: ql.featureTypes,
            };
        });
});

export default getQuickLinks;
